// src/components/utils/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { currentUser, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return <div>Ładowanie...</div>; // lub jakiś spinner
    }

    if (!currentUser) {
        // Przekieruj na stronę logowania, zapamiętując skąd przyszedł użytkownik
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;